import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import FastFacts from "./components/FastFacts";
import FocusSection from "./components/FocusSection";
import IndexCollection from "./components/IndexCollection";
import Timeline from "./components/Timeline";
import Credibility from "./components/Credibility";
import ClosingBand from "./components/ClosingBand";
import Footer from "./components/Footer";

function Home() {
  return (
    <div className="min-h-screen bg-background-50 font-body text-foreground-950 antialiased">
      <Navbar />
      <main>
        <Hero />
        <FastFacts />
        <FocusSection />
        <IndexCollection />
        <Timeline />
        <Credibility />
        <ClosingBand />
      </main>
      <Footer />
    </div>
  );
}

export default Home;